import { useCurrentUser } from '@bonusly/who-am-i';

import { spendableAllowanceBalance } from '../../../../utils/allowance';

/**
 * Shared "can give points / an amount?" rules for chips and amount affordances.
 * Also returns `spendableBalance` (what those surfaces display) and
 * `hasRecurringAllowance` (monthly allowance vs adjustment-only balance).
 */
export const useGivePointsCapabilities = () => {
	const user = useCurrentUser();

	const canGivePoints = user.can_give_non_zero;
	// Adjustments land in `giving_balance` only; flash points have their own chip. (RR-300)
	const spendableBalance = spendableAllowanceBalance(user.giving_balance, user.flash_points_balance);
	const hasPointsToGive = user.monthly_allowance > 0 || spendableBalance > 0;

	const canGiveAmount = canGivePoints && hasPointsToGive;

	return { canGivePoints, canGiveAmount, spendableBalance, hasRecurringAllowance: user.monthly_allowance > 0 };
};
